<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="设备使用记录详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">使用人:</el-col>
        <el-col :span="19">
          <el-avatar shape="square" :size="32" :src="showForm.basic.profile.avatar"></el-avatar>
          <div>{{ showForm.basic.profile.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">操作类型:</el-col>
        <el-col :span="19">{{ formatCommand(showForm) }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">设备标题:</el-col>
        <el-col :span="19">
          {{ showForm.basic.deviceTitle }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">设备位置:</el-col>
        <el-col :span="19">
          {{ showForm.basic.deviceAddress }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">开始时间:</el-col>
        <el-col :span="19">
          {{ showForm.basic.startTime && moment(showForm.basic.startTime).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">按摩位置:</el-col>
        <el-col :span="19">
          {{ formatPlace(showForm) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">按摩力度:</el-col>
        <el-col :span="19">
          {{ formatPower(showForm) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">预计结束时间:</el-col>
        <el-col :span="19">
          {{ showForm.basic.closeTime && moment(showForm.basic.closeTime).format('YYYY-MM-DD HH:mm:ss') || '' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">实际结束时间:</el-col>
        <el-col :span="19">
          {{ showForm.basic.realCloseTime && moment(showForm.basic.realCloseTime).format('YYYY-MM-DD HH:mm:ss') || '' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">操作时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import config from './config'
import { findDeviceRecord } from '@/api/alfmeier'
export default {
  name: 'AlfmeierDeviceRecordDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    formatPlace(row) {
      const find = config.places.find(e => e.value == row.basic.place)
      return find && find.label || '未知'
    },
    formatPower(row) {
      const find = config.powers.find(e => e.value == row.basic.power)
      return find && find.label || '未知'
    },
    formatCommand(row) {
      const find = config.commands.find(e => e.value == row.basic.command)
      return find && find.label || '未知'
    },
    async show(row) {
      const deviceRecordId = row.deviceRecordId
      this.row = row
      const data = await findDeviceRecord({
        deviceRecordId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
